<template>
    <div>
        <div class="tit">
            <span>1.填写标题</span>
            <span>温馨提示：每个指标都必须预测。</span>
        </div>
        <div class="qihao">
            [{{vuex_userInfo.userName}}]大乐透第{{form.number}}期缩水师预测
            <input type="text"
                   v-model="form.title">
        </div>
        <div style="color:red;text-align: center;width: 100%;padding-bottom: 8px;">发缩水单在开奖当天18:00点截止，重新上传或者编辑到我的专栏</div>
        <div class="tit">
            <span>2.预测列表</span>
            <span>温馨提示：每个指标都需要预测</span>
            <div>
                <span style="cursor: pointer;" @click="$router.push('/article_details?id=28&type=help')">收费标准</span>
                <span style="cursor: pointer;" @click="$router.push('/article_details?id=52&type=help')">积分规则</span>
                <span style="cursor: pointer;" @click="$router.push('/article_details?id=47&type=help')">阶梯提成</span>
            </div>
        </div>
        <el-dialog
        title="软件格式"
        :visible.sync="showImgDialog"
        width="60%"
        center>
            <div style="text-align: center;">
                <img src="@/assets/imglog/dlt.png"/>
            </div>
        </el-dialog>

        <div class="list">
            <div style="position: relative;"> <span>预测指标</span> <span>操作</span>
                <span class="cttitle" @click="showImgDialog=true">系统默认天云和大赢家这样主流软件格式</span>
                <a class="cttitle ctitle2" href="http://6.36886.net/stage-api/profile/upload/1/41/pre_other_file/2024/10/24/天云大乐透_20241024135641A005.zip" download>下载天云大乐透</a>
              <span class="tish">
                  发单格式:期数+用户名+注数<br />
                  实例:2024115-李小龙-88.8万<br/>
                  <b style="color: red">温馨提示:用电信网络上传文件速度较快</b>
              </span>
            </div>
            <div> <span>27-29.9万</span> <span> <input type="file"
                           data-type="7"
                           data-fileType="pre_index_lottery_twenty_seven_w"
                           accept=".txt"
                           @change="chooseFile"> </span> </div>
            <div> <span>24-26.9万</span> <span> <input type="file"
                           data-type="0"
                           data-fileType="pre_index_lottery_twenty_four_w"
                           accept=".txt"
                           @change="chooseFile"></span> </div>
            <div> <span>15-17.9万</span> <span> <input type="file"
                           data-type="1"
                           data-fileType="pre_index_lottery_fifteen_w"
                           accept=".txt"
                           @change="chooseFile"></span> </div>
            <div> <span>3-5.9万</span> <span> <input type="file"
                           data-type="2"
                           data-fileType="pre_index_lottery_three_w"
                           accept=".txt"
                           @change="chooseFile"></span> </div>
            <div> <span>1-1.9万</span> <span> <input type="file"
                           data-type="3"
                           data-fileType="pre_index_lottery_one_w"
                           accept=".txt"
                           @change="chooseFile"></span> </div>
            <div> <span>4368注以下</span> <span> <input type="file"
                           data-type="4"
                           data-fileType="pre_index_lottery_four_k"
                           accept=".txt"
                           @change="chooseFile"></span> </div>
            <div class="inp">
                <span>杀5后</span>
                <span>
                    <div class="sha5">
                        <span v-for="(item,index) in sha5"
                              :key="index"
                              @click="C_num('sha5',index,item.ischeck,)"
                              :class="{
								ischeck:item.ischeck,
								gray:item.gray,
							}">{{item.num}}</span>
                    </div>
                    <div v-if="select.sha5">已选择：{{select.sha5}}</div>
                    <div>
                        <!-- <el-button @click="suiji(6)" type="primary" size="small">随机</el-button> -->
                        <el-button @click="confirm(5)"
                                   type="success"
                                   size="small">确定</el-button>
                        <el-button @click="reset(5)"
                                   type="danger"
                                   size="small">重置</el-button>
                    </div>

                    <!-- <input type="text"
                           data-type="5"
                           data-fileType="pre_index_lottery_five"
                           accept=".txt"
                           @input="jianting_inp">
                    <div>请输入要杀掉的 <b>5</b> 个篮球 (球号之间以空格分开) </div> -->
                </span>
            </div>
            <div class="inp">
                <span>围3后</span>
                <span>
                    <div class="wei3">
                        <span v-for="(item,index) in wei3"
                              :key="index"
                              @click="C_num('wei3',index,item.ischeck,)"
                              :class="{
								ischeck:item.ischeck,
								gray:item.gray,
							}">{{item.num}}</span>
                    </div>

                    <div v-if="select.wei3">已选择：{{select.wei3}}</div>

                    <div>
                        <!-- <el-button @click="suiji(4)" type="primary" size="small">随机</el-button> -->
                        <el-button @click="confirm(3)"
                                   type="success"
                                   size="small">确定</el-button>
                        <el-button @click="reset(3)"
                                   type="danger"
                                   size="small">重置</el-button>
                    </div>
                    <!-- <input type="text"
                           data-type="6"
                           data-fileType="pre_index_lottery_three"
                           accept=".txt"
                           @input="jianting_inp">
                    <div>请输入要围掉的 <b>3</b> 个篮球 (球号之间以空格分开) </div> -->
                </span>
            </div>
        </div>

        <div style="
            margin: 10px 0;
            display: flex;
        ">
            <span style="margin-right:10px">预测说明</span>
            <textarea name=""
                      id=""
                      cols="100"
                      rows="10"
                      style="user-select:none;resize: none;"
                      v-model="form.preRemark"
                      placeholder="温馨提示:可以介绍自己没有使用常规条件，极限条件等危险条件过滤,而是采用比较稳妥的分布过滤，冷码过滤，一级容错，二级容错，甚至三级容错技术，自我评估本期多大的单又多大的把握，提高自己的被认购率"></textarea>
        </div>

        <el-button type="primary"
                   @click="save">确定发布</el-button>

    </div>
</template>

<script>
import { queryUuIdInfo, upLoadFile } from "@/api/common"
import Mixin from '@/views/personalCenter/sss_yuce/minix'
let mixin = new Mixin({
    lotteryType: '1',    //彩种
    lotteryName: '大乐透',    //彩种
})

export default {
    mixins: [mixin],
    name: 'dlt',
    data () {
        return {
            showImgDialog: false,
            sha5: Array.from({ length: 12 }, (v, i) => { return { num: i + 1, ischeck: false, gray: false } }),
            wei3: Array.from({ length: 12 }, (v, i) => { return { num: i + 1, ischeck: false, gray: false } }),

            select: {
                sha5: '',
                wei3: '',
            },
        }
    },
    methods: {
        async confirm (type) {
            let activeArr = this[type == 5 ? 'sha5' : 'wei3'].filter(item => item.ischeck).map(item => item.num)

            if (activeArr.length != type) {
                return this.$message.error(`请选择${type}个篮球`)
            }

            this.select[type == 5 ? 'sha5' : 'wei3'] = padZeros(activeArr).join(' ')

            let { number } = this.form
            this.form.preRecordDetailDtoList.push({
                id: await queryUuIdInfo(),
                title: `大乐透第（${number}）期缩水预测 `,
                // realBetNumber:'' ,     //文件行数上传文件成功后有返回
                preIndexType: type == 5 ? 5 : 6,		//指标标识
                number,
                preType: 1,	//彩种
                expand: this.select[type == 3 ? 'wei3' : 'sha5'],	//输入的数字   围3杀5这些

                createUser: this.vuex_userInfo.userId,
                productModel: '0', //商品所属模块：商品类别:0（预测缩水单商品），1（EXCEL专场商品），2（缩水软件特区商品；【product_model】
                backNumber: '20',
            })


            function padZeros (arr) {
                return arr.map(num => {
                    // 将数字转换为字符串
                    const str = num.toString();
                    // 如果字符串长度小于2，则在前面补0
                    return str.length < 2 ? `0${str}` : str;
                });
            }

        },
        // 重置
        reset (type) {
            this[type == 6 ? 'sha5' : 'wei3'] = Array.from({ length: 16 }, (v, i) => { return { num: i + 1, ischeck: false, gray: false } })
            this[type == 6 ? 'wei3' : 'sha5'].forEach(item => item.gray = false)

            this.select[type == 6 ? 'sha5' : 'wei3'] = ''

        },

        // 杀6围4
        C_num (type, index, ischeck) {
            if (this[type][index].gray) return;
            if (ischeck == false) {
                if (this[type].filter(item => item.ischeck).length >= (type == 'sha5' ? 5 : 3)) {
                    return this.$message.error(`最多选择${(type == 'sha5' ? 5 : 3)}个篮球`)
                }
            }
            this.$set(this[type][index], 'ischeck', !ischeck)
            this.$set(this[type == 'sha5' ? 'wei3' : 'sha5'][index], 'gray', !ischeck)
        },
    }
};
</script>

<style lang="scss" scoped>
@import './yuce.scss';

.sha5,
.wei3 {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    grid-gap: 5px;
    margin-bottom: 10px;
    span {
        height: 20px;
        padding: 0 !important;
        display: inline-block;
        aspect-ratio: 1 /1;
        line-height: 20px;
        text-align: center;
        border-radius: 50%;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.4);
        cursor: pointer;
        &.gray {
            background-color: #ccc;
        }
        &.ischeck {
            background-color: #2899df;
        }
    }
    > div {
        white-space: nowrap;
    }
    .random {
        cursor: pointer;
    }
    // &.sha4{
    // 	span{
    // 		&.ischeck{
    // 			background-color: red;
    // 		}
    // 	}
    // }
}
.cttitle{
    position: absolute;
    left: 100%;
    width: 307px;
    cursor: pointer;
    color: #1956a6;
    user-select: none;
    border: 0 !important;
    font-weight: 600;
    text-align: left;
    padding: 10px;
    text-decoration: underline;
}
.tish{
    line-height: 50px;
  position: absolute;
  left: 100%;
  width: 307px;
  //cursor: pointer;
  //color: #1956a6;
  //user-select: none;
  border: 0 !important;
  //font-weight: 600;
  text-align: left;
  //padding: 10px;
  //text-decoration: underline;
  margin-top: 80px;
}
.ctitle2{
        display: block;
    top: 30px;
    text-align: left;
}
</style>








